import useCart from "@/src/hooks/useCart";
import { client } from "@/src/utils/apollo";
import { gql } from "@apollo/client";
import Link from "next/link";
import { useCallback, useEffect, useState } from "react";
import {
  Collapse,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
} from "reactstrap";
import { MenuItemWithAnimation } from "./animation";
import styles from "./horizontal.module.css";

const GET_MENU = gql`
  query Groups($filters: GroupFilterInput) {
    groups(filters: $filters) {
      rows {
        name
        is_principal
        image {
          src
          id_image
          alt
        }
        description
        id_group
      }
    }
  }
`;

export default function HorizaontalMenu({ ...args }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(() => {
    // Recuperar el estado sticky de sessionStorage si existe
    if (typeof window !== "undefined") {
      const storedSticky = sessionStorage.getItem("isSticky");
      return storedSticky === "true";
    }
    return false;
  });
  const toggle = useCallback(() => setIsOpen((prevState) => !prevState), []);
  const { cart } = useCart();

  const [menu, setMenu] = useState<IGropMenyType[]>([]);
  const fetchMenu = async () => {
    try {
      const filters = {};
      const response = await client.query({
        query: GET_MENU,
        variables: { filters },
      });
      setMenu(response.data.groups.rows);
    } catch (error) {
      console.error("Error fetching menu:", error);
    }
  };

  // Handle scroll event to make navbar sticky
  const handleScroll = useCallback(() => {
    if (window.scrollY > 180) {
      setIsSticky(true);
      // Guardar el estado en sessionStorage para mantenerlo entre navegaciones
      sessionStorage.setItem("isSticky", "true");
    } else {
      setIsSticky(false);
      sessionStorage.setItem("isSticky", "false");
    }
  }, []);

  // Mantener el estado sticky cuando se navega entre páginas
  useEffect(() => {
    // Comprobar la posición actual del scroll al cargar el componente
    handleScroll();
  }, [handleScroll]);

  // Asegurar que el estado sticky se mantenga actualizado
  useEffect(() => {
    // Verificar la posición inicial del scroll
    if (window.scrollY > 180) {
      setIsSticky(true);
    }
  }, []);

  useEffect(() => {
    fetchMenu();

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  const menuItems = menu.map((item) => ({
    href: `/categoria/${item.id_group}/${item.name}`,
    text: item.name,
  }));

  const renderNavItems = () =>
    menuItems.map((item, index) => (
      <MenuItemWithAnimation
        key={item.href}
        href={item.href}
        text={item.text}
      />
    ));
  const renderNavItemsMobile = () =>
    menuItems.map((item, index) => (
      <NavItem key={index}>
        <Link
          className="nav-link"
          href={item.href}
          onClick={(e) => {
            toggle();
          }}
        >
          {item.text}
        </Link>
      </NavItem>
    ));

  return (
    <>
      <header
        id="stickyheader"
        className={isSticky ? styles["sticky-active"] : ""}
      >
        <Navbar
          className={`navbar-dark  ${
            isSticky ? styles["sticky-navbar justify-content-center"] : ""
          }`}
          container="fluid"
          expand="md"
          {...args}
        >
          {/* Only show toggler on mobile */}
          <div className="d-flex justify-content-center d-md-none">
            <NavbarToggler
              onClick={toggle}
              style={{
                border: "1px solid #12E507FF",
                color: "#12E507FF",
                padding: "1rem 1rem",
              }}
            >
              <i className="fa fa-bars sidebar-bar "></i>
            </NavbarToggler>
            {isSticky && (
              <NavbarBrand
                href="/"
                className="d-flex d-md-none align-items-center  "
                style={{
                  justifyContent: "center",
                }}
              >
                <img
                  src="/images/logo/logo-dark.png"
                  alt="Logo"
                  style={{
                    width: "auto",
                    height: "40px",
                    marginLeft: "2rem",
                  }}
                />
              </NavbarBrand>
            )}
          </div>

          {/* Regular menu for md and larger screens */}
          <Collapse navbar className="d-none d-md-block justify-content-center">
            <Nav
              className="navHeader"
              style={{
                justifyContent: "center",
              }}
              navbar
            >
              {isSticky && (
                <NavbarBrand
                  href="/"
                  className="d-flex d-md-none d-lg-flex align-items-center"
                  style={{
                    justifyContent: "center",
                  }}
                >
                  <img
                    src="/images/logo/logo-dark.png"
                    alt="Logo"
                    style={{
                      width: "auto",
                      height: "35px",
                    }}
                  />
                </NavbarBrand>
              )}

              <MenuItemWithAnimation href="/" text="INICIO" />

              <MenuItemWithAnimation href="/general" text="GENERAL" />

              {renderNavItems()}
              {/* {isSticky && (
                <>
                  <NavItem className="cart-block cart-hover-div">
                    <div className="cart ">
                      <span className="cart-product">{cart.totalQuantity}</span>
                      <ul>
                        <li className="mobile-cart">
                          <Link href="/carrito">
                            <i
                              className="icon-shopping-cart "
                              style={{
                                color: "white",
                              }}
                            ></i>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </NavItem>
                </>
              )} */}
            </Nav>
          </Collapse>

          {/* Offcanvas for mobile */}
          <Offcanvas
            direction="start"
            isOpen={isOpen}
            toggle={toggle}
            className="d-md-none menu-offcanvas"
          >
            <OffcanvasHeader toggle={toggle}>Menu</OffcanvasHeader>
            <OffcanvasBody>
              <Nav className="justify-content-center flex-grow-1 pe-3" navbar>
                <NavItem
                  onClick={(e) => {
                    toggle();
                  }}
                >
                  <Link href="/" className="nav-link">
                    INICIO
                  </Link>
                </NavItem>
                <NavItem
                  onClick={(e) => {
                    toggle();
                  }}
                >
                  <Link href="/general" className="nav-link">
                    GENERAL
                  </Link>
                </NavItem>
                {renderNavItemsMobile()}
              </Nav>
            </OffcanvasBody>
          </Offcanvas>
        </Navbar>
      </header>
    </>
  );
}
